import { IconDelete } from "@suse-o11y/icons";
import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";

import { PromQLInput } from "../../../../metrics/PromQLInput";
import { Widget } from "../../../_widget";

import type { SeriesSelectorState } from "./_form-state";

export interface SelectorProps {
	onDelete: VoidFunction;
	state: SeriesSelectorState;
}

export const Selector = React.forwardRef<React.ElementRef<typeof Widget>, SelectorProps>(({ onDelete, state }, ref) => (
	<Widget card className="grid grid-cols-[max-content_1fr_auto] gap-2" ref={ref}>
		<FormField className="col-span-full grid grid-cols-subgrid" layout="horizontal" state={state}>
			<FormLabel>Selector</FormLabel>

			{(monitor, field) => (
				<PromQLInput
					completionTypes={["constant", "text"]}
					onChange={(value) => field.setInput(value)}
					size="sm"
					value={field.getInput(monitor)}
				/>
			)}

			<button className="button button-tertiary button-sm button-square" onClick={onDelete} type="button">
				<IconDelete className="size-3" />
			</button>

			<FormFieldErrorMessage className="col-start-2" />
		</FormField>
	</Widget>
));
